import React, { useState } from 'react';
import useIsAuthenticated from '../../../Hooks/useIsAuthenticated';
import Icon from '../../Icon';
import { translate } from '../../../Services/translation';
import { useDispatch, useSelector } from 'react-redux';
import { setLoginModalOpen, signOut, setLoginMode, setOrganizations } from '../../../Actions/Login.action';
import { setMobileMenuOpen } from '../../../Actions/Navigation.action';
import clsx from 'clsx';
import { LoginModes } from '../../../constants';

const MobileNavigationDropdown = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const isAuthenticated = useIsAuthenticated();
  const dispatch = useDispatch();
  const { person, pageUrl, links, organizations } = useSelector((state) => state.myPage.menu);

  const handleSignInClick = () => {
    dispatch(setMobileMenuOpen(false));
    dispatch(setLoginModalOpen(true));
  };

  const handleSignOutClick = () => {
    signOut();
    dispatch(setMobileMenuOpen(false));
  };

  const onChangeOrgClick = () => {
    dispatch(setMobileMenuOpen(false));
    dispatch(setOrganizations(organizations));
    dispatch(setLoginMode(LoginModes.SelectOrganization));
    dispatch(setLoginModalOpen(true));
  };

  return (
    <li
      className={clsx(
        'navigation-mobile__list-item navigation-mobile__dropdown',
        dropdownOpen && 'navigation-mobile__dropdown--open'
      )}
    >
      {!isAuthenticated ? (
        <button
          className="navigation-mobile__button navigation-mobile__dropdown-button"
          onClick={() => handleSignInClick()}
        >
          <Icon
            name="Person"
            size={24}
            className="navigation-mobile__dropdown-icon"
          />
          {translate('general.sign-in')}
        </button>
      ) : (
        <>
          <button
            className="navigation-mobile__button navigation-mobile__dropdown-button"
            onClick={() => setDropdownOpen(!dropdownOpen)}
          >
            <Icon
              name="Person"
              size={24}
              className="navigation-mobile__dropdown-icon"
            />
            {person.name && person.name}
            <Icon
              className="navigation-mobile__icon"
              name="Caret-Down"
              size={24}
            />
          </button>
          <div className="navigation-mobile__dropdown-content">
            {organizations && organizations.length > 1 && (
              <>
                <button
                  className="link-menu__item link-menu__item--top"
                  onClick={() => onChangeOrgClick()}
                >
                  <Icon
                    size={24}
                    name="Home-Cog"
                    className="link-menu__item-icon"
                  />
                  <span className="link-menu__item-label">
                    {translate('mypages.changeorg')}
                  </span>
                </button>
                <div className="link-menu__divider"></div>
              </>
            )}
            {links &&
              !!links.length &&
              links.map(
                (link) =>
                  !link.isDivider && (
                    <a
                      href={pageUrl + '#' + link.urlParam}
                      className="link-menu__item"
                      key={link.label}
                      onClick={() => dispatch(setMobileMenuOpen(false))}
                    >
                      {link.icon && (
                        <Icon
                          size={24}
                          name={link.icon}
                          className="link-menu__item-icon"
                        />
                      )}
                      {link.label && (
                        <span className="link-menu__item-label">
                          {link.label}
                        </span>
                      )}
                    </a>
                  )
              )}
            <button
              className="link-menu__item"
              onClick={() => handleSignOutClick()}
            >
              <Icon
                size={24}
                name="Sign-Out"
                className="link-menu__item-icon"
              />
              <span className="link-menu__item-label">
                {translate('general.sign-out')}
              </span>
            </button>
          </div>
        </>
      )}
    </li>
  );
};

export default MobileNavigationDropdown;
